import env from '../../../env';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { Dropdown } from '../../../components/Dropdown';
import _ from 'lodash';
import { setTransportOrderProperties } from '../actions';
import { Loader } from '../../../components/Loader';

import cn from 'classnames';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import styles from './CardTransportOrderStatus.module.css';
import { selectWork } from '../../Api/selectors';
import {
  REQUEST_TRANSPORT_ORDER_PROPERTY_UPDATE,
  TRANSPORT_ORDER_STATUS,
  TRANSPORT_ORDER_STATUS_OPTIONS,
} from '../constants';

const STATE = {
  edit: false,
  status_remark: '',
};
/* eslint-disable react/prefer-stateless-function */
class TransportOrderStatusCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.setStatusLogs && this.props.vehicle?.status_remark) {
      this.setState({ status_remark: this.props.vehicle?.status_remark });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.setStatusLogs) {
      this.state.edit !== prevState.edit && this.setState({ status_remark: this.props.vehicle?.status_remark });
    }
  }

  get options() {
    // 'requested' | 'initiated' | 'done' | 'canceled';
    return TRANSPORT_ORDER_STATUS_OPTIONS.map(value => ({
      label: this.lbl(`transport_order.property.status.${value}`),
      value: `${value}`,
    }));
  }

  get selected() {
    return this.options.find(o => o.value == this.state.selected);
  }

  onChange(v) {
    this.setState({ selected: v.value, edit: true });
  }

  save() {
    this.setState({ loading: true });

    this.props.onChange(this.state.selected, result => {
      this.setState({ loading: false, edit: false });
    });
  }
  toggleEdit = () => {
    this.setState(prevState => ({ edit: !prevState.edit }));
  };

  componentDidUpdate(prevProps, prevState) {}

  render() {
    const currentStatus = this.selected?.value || this.props.transportOrder?.status || '0';
    const dropdownClass = cn({
      [styles.dropdown]: true,
      [styles.dropdownStatus0]: currentStatus === TRANSPORT_ORDER_STATUS.Requested,
      [styles.dropdownStatus3]: currentStatus === TRANSPORT_ORDER_STATUS.Initiated,
      [styles.dropdownStatus2]: currentStatus === TRANSPORT_ORDER_STATUS.Done,
      [styles.dropdownStatus1]: currentStatus === TRANSPORT_ORDER_STATUS.Canceled,
      // [styles.dropdownStatus4]: currentStatus === '4',
      // [styles.dropdownStatus5]: currentStatus === '5',
      // [styles.dropdownStatus6]: currentStatus === '6',
    });
    return (
      <div className={styles.dropdownBox}>
        <div className={styles.container}>
          <Dropdown
            className={dropdownClass}
            options={this.options}
            value={this.selected}
            onChange={this.onChange.bind(this)}
            disabled={this.state.loading}
            placeholder={this.props.transportOrder?.status}
          />
        </div>

        {this.state.edit && this.state.selected && (
          <>
            <ButtonComponent size={'btn-sm'} style={'ButtonSoftEdit'} onClick={() => this.save()}>
              {this.props.workUpdate ? <Loader small /> : this.lbl('save')}
            </ButtonComponent>
          </>
        )}
      </div>
    );
  }
}

TransportOrderStatusCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workUpdate: selectWork(REQUEST_TRANSPORT_ORDER_PROPERTY_UPDATE),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    onChange(status, callback) {
      dispatch(setTransportOrderProperties(ownProps.transportOrder?.id, { status }, callback));
    },
    removeStatusInfo(vehicleId, propertyName, callback) {
      dispatch(deleteVehicleProperty(vehicleId, propertyName, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportOrderStatusCard = compose(withConnect, withRouter)(TransportOrderStatusCardComp);
